import { Flashlight, ChevronDown } from 'lucide-react';
import { QCM_GREEN, QCM_AMBER } from '../../utils/qcmTheme';

/**
 * Bandeau haut de la vue scan : numéro de question et, à côté, la pastille
 * de la taille analysée (1080p, 720p ou 540p, choisie par le réglage
 * automatique du scanner, 2026-09-22 : le prof voit où en est son téléphone,
 * et un 540p explique pourquoi il ne capte pas de loin ; un tap ouvre le
 * choix, cf. ChoixTaille), compteur géant X/Y (tappable → détail des réponses
 * par carte), barre de progression, torche.
 */
const ScanHeader = ({
  numeroQuestion, sousTitre = 'Scan en cours', done, total,
  qualite = null, onChoisirTaille,
  torchSupported, torchOn, onToggleTorch,
  onOuvrirReponses,
}) => {
  const pct = total > 0 ? (done / total) * 100 : 0;

  return (
    <div className="relative z-[4] px-4 pt-4 pb-2.5 text-white" style={{ background: 'linear-gradient(rgba(0,0,0,.85), transparent)' }}>
      <div className="flex items-center justify-between gap-2.5">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <p className="text-[11px] font-bold uppercase" style={{ letterSpacing: '.14em', color: '#a9e8c9', fontFamily: "'Archivo', 'Inter', system-ui, sans-serif" }}>
              Question {numeroQuestion} · {sousTitre}
            </p>
            {qualite ? (
              <button
                type="button"
                onClick={onChoisirTaille}
                data-testid="qualite-analyse"
                title="Taille de l'image analysée : plus petite, le téléphone va plus vite mais capte moins loin. Toucher pour choisir."
                className="px-1.5 py-[1px] rounded-md text-[10px] font-black tabular-nums leading-tight flex-shrink-0 active:opacity-70"
                style={{ background: 'rgba(255,255,255,.14)', border: '1px solid rgba(255,255,255,.28)', color: '#fff', fontFamily: "'Archivo', 'Inter', system-ui, sans-serif" }}
              >
                {qualite}
              </button>
            ) : null}
          </div>
          {/* Compteur tappable → détail « qui a répondu quoi » */}
          <button
            type="button"
            onClick={onOuvrirReponses}
            aria-label="Voir le détail des réponses par élève"
            className="flex items-center leading-none mt-0.5 text-white active:opacity-70"
            style={{ fontFamily: "'Archivo', 'Inter', system-ui, sans-serif" }}
          >
            <span className="font-black text-[26px] tabular-nums">{done}/{total}</span>
            <span className="ml-1 text-[13px] font-semibold" style={{ color: '#c8cec6' }}>élèves</span>
            <ChevronDown size={15} className="ml-0.5" style={{ color: '#c8cec6' }} />
          </button>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {torchSupported && (
            <button
              type="button"
              onClick={onToggleTorch}
              aria-label={torchOn ? 'Éteindre la torche' : 'Allumer la torche'}
              className="w-[42px] h-[42px] rounded-full flex items-center justify-center transition"
              style={torchOn
                ? { background: QCM_AMBER, border: `1.5px solid ${QCM_AMBER}`, color: '#3a2a00' }
                : { background: 'rgba(255,255,255,.08)', border: '1.5px solid rgba(255,255,255,.33)', color: '#fff' }}
            >
              <Flashlight size={18} />
            </button>
          )}
        </div>
      </div>
      <div className="h-[5px] rounded-full mt-3 overflow-hidden" style={{ background: 'rgba(255,255,255,.15)' }}>
        <div
          className="h-full rounded-full"
          style={{ width: `${pct}%`, background: QCM_GREEN, transition: 'width .4s cubic-bezier(.2,.8,.3,1)' }}
        />
      </div>
    </div>
  );
};

export default ScanHeader;
